import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import CryptoJS from 'crypto-js';
import configJson from '../../Config.json';

const IConnectHome = () => {
  const auth = useAuth();

  const encryptString = (strInputData) => {
    const keyValue = configJson.HRMSValue;
    const key = CryptoJS.enc.Utf8.parse(keyValue.padEnd(16, '\0'));
    const iv = CryptoJS.enc.Utf8.parse(keyValue.padEnd(16, '\0'));

    const encrypted = CryptoJS.AES.encrypt(strInputData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
};

  useEffect(() => {
    if (auth.isAuthenticated && auth.user?.profile) {
      const profile = auth.user.profile;
      const identity = profile.identities?.[0];

      if (identity) {
        const providerName = identity.providerName;
        const rawUserId = identity.userId;

        localStorage.setItem("providerName", providerName);

        const date = new Date();
        date.setSeconds(date.getSeconds() + 20);
        const datePart = date.toISOString().split('T')[0];
        const timePart = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
          timeZone: 'UTC' 
      });
        const userID = `rr${rawUserId}~${datePart} ${timePart}`;     
        if (userID) {
          const EncryptuserID = encryptString(userID);
          const targetUrl = `${configJson.Hrmsbase}/Login/ExternalLogin?` + 
                            `RRLogin=${encodeURIComponent(EncryptuserID)}&` + 
                            `RedirectAppDomailURL=""&` + 
                            `AppId=""&domain=AS`;

          window.location.href = targetUrl;
        }
      }
    }
  }, [auth.isAuthenticated, auth.user]);

  if (auth.isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p>Verifying session, please wait...</p>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p>Redirecting to login...</p>
      </div>
    );
  }

  return null;
};
export default IConnectHome;